import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { AuthModal } from "@/components/AuthModal";
import Landing from "@/pages/Landing";
import Library from "@/pages/Library";
import Pricing from "@/pages/Pricing";
import Dashboard from "@/pages/Dashboard";
import Verify from "@/pages/Verify";
import Success from "@/pages/Success";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="noise" />
        <AuthModal />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/library" element={<Library />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/success" element={<Success />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy" element={<Legal />} />
          <Route path="/terms" element={<Legal />} />
          <Route path="/refunds" element={<Legal />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
